import { QuestionnaireAnswerType } from 'components/Assessments/types'
import { AuthorizationQuestionnaireItem } from './questionnaire'

export const AUTHORIZATION_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE = {
  [AuthorizationQuestionnaireItem.AUTHORIZATION]: QuestionnaireAnswerType.GROUP,
  [AuthorizationQuestionnaireItem.AUTHORIZATION_AUTHORIZATION]: QuestionnaireAnswerType.GROUP,
  [AuthorizationQuestionnaireItem.AUTHORIZATION_AUTHORIZATION_AUTHORIZATION_SOURCE]:
    QuestionnaireAnswerType.REFERENCE,
  [AuthorizationQuestionnaireItem.AUTHORIZATION_AUTHORIZATION_CURRENT_HOURS]:
    QuestionnaireAnswerType.DECIMAL
}
